import { EINV_SUMMARY_DATA, FETCH_FILTER_RETURN_PERIOD, FETCH_RECO_DATA, LOADER_STATUS, RECO_LINE_SUMMARY_DATA, RECO_SUMMARY_DATA, UPLOAD_HISTORY_DATA } from "./constants";

export const initialState = {
    loaderStatus: false, 
    fetchRecoTableData:[],
    einvSummaryTableData:[],
    recoSummaryTableData:[],
    recoLineSummaryTableData:[],
    uploadHistoryTableData:[],
    selectedFetchFilterReturnPeriod: null,
};
  
  /* eslint-disable default-case, no-param-reassign */
  const gstr1NewFetchAndReconcileReducer = (state = initialState, action) =>{
      switch (action.type) {
        
        case LOADER_STATUS:
          return {
            ...state,
            loaderStatus:action.loaderStatus
          }
          case FETCH_RECO_DATA:
            return {
              ...state,
              fetchRecoTableData:action.fetchRecoTableData
            }
            case EINV_SUMMARY_DATA:
            return {
              ...state,
              einvSummaryTableData:action.einvSummaryTableData
            }
            case RECO_SUMMARY_DATA:
              return{
                ...state,
                recoSummaryTableData: action.recoSummaryTableData
              }
              case RECO_LINE_SUMMARY_DATA:
                return{
                  ...state,
                  recoLineSummaryTableData:action.recoLineSummaryTableData
                }
                case UPLOAD_HISTORY_DATA:
                  return{
                    ...state,
                    uploadHistoryTableData:action.uploadHistoryTableData
                  }
                  case FETCH_FILTER_RETURN_PERIOD:
                    return {
                      ...state,
                      selectedFetchFilterReturnPeriod: action.date,
                    };  
        default:
          return state;
      }
    };
  
  export default gstr1NewFetchAndReconcileReducer;